"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Price = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var material_1 = require("@mui/material");
var utils_1 = require("../utils");
var Price = function (_a) {
    var amount = _a.amount, term = _a.term, _b = _a.color, color = _b === void 0 ? 'primary.500' : _b, dataCy = _a["data-cy"];
    var localeAmount = (0, utils_1.currencyFormatter)(amount);
    var _c = (0, react_1.useState)(''), dollarAmount = _c[0], setDollarAmount = _c[1];
    var _d = (0, react_1.useState)(''), centAmount = _d[0], setCentAmount = _d[1];
    (0, react_1.useEffect)(function () {
        if (localeAmount.includes('.')) {
            setDollarAmount(localeAmount.split('.')[0]);
            setCentAmount(localeAmount.split('.')[1]);
        }
        else {
            setDollarAmount(localeAmount);
        }
    }, [localeAmount]);
    return ((0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ component: "p" }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ component: "span", sx: {
                    fontSize: '5.2rem',
                    fontWeight: 'bold',
                    lineHeight: 1,
                    color: color,
                }, "data-cy": dataCy }, { children: ["".concat(dollarAmount), centAmount && centAmount !== '00' && ((0, jsx_runtime_1.jsxs)(material_1.Typography, __assign({ component: "span", variant: "body2XLarge", sx: { fontWeight: 800 } }, { children: [".", centAmount] })))] })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: "span", variant: "bodySmall", sx: { color: 'primary.400' } }, { children: term && "/ ".concat(term) }))] })));
};
exports.Price = Price;
